<div style="margin-left: -15px; margin-right: -15px">
  <sub-nav [menu]="menu"></sub-nav>
  <div class="container-fluid" style="padding-top: 40px">
    <router-outlet></router-outlet>
  </div>
</div>
